export default __webpack_public_path__ + "static/media/chevronDown.3e840ec1.svg";